<div class="form-floating" style="width:100%">
  <input  id="GrundSelect" style="width:100%" class="form-control" [ngModel]="CurrentSelected" (ngModelChange)="onValueChangeEvent($event)"
			[ngbTypeahead]="search"
			[inputFormatter]="formatter"
			[resultFormatter]="formatter"
			[selectOnExact]="true"/>

  <label for="GrundSelect">Ablehnung Grund</label>
</div>
